module.exports = __webpack_public_path__ + "img/mail36x36.2302a109.png";